import { DemoCostAndUsageReportsComponent } from './demo-cost-and-usage-reports/demo-cost-and-usage-reports.component';
import { DemoDashboardComponent } from './demo-dashboard/demo-dashboard.component';
import { DemoLiveViewComponent } from './demo-live-view/demo-live-view.component';
import { DemoManageChangeSpendLimitComponent } from './demo-manage-change-spend-limit/demo-manage-change-spend-limit.component';
import { DemoManageChangeTariffPlanComponent } from './demo-manage-change-tariff-plan/demo-manage-change-tariff-plan.component';
import { DemoSimManagementComponent } from './demo-sim-management/demo-sim-management.component';
import { DemoUserManagementComponent } from './demo-user-management/demo-user-management.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: "cost-and-usage-reports",
    component: DemoCostAndUsageReportsComponent
  },
  {
    path: "dashboard",
    component: DemoDashboardComponent
  },
  {
    path: "live-view",
    component: DemoLiveViewComponent
  },
  {
    path: "manage-change-spend-limit",
    component: DemoManageChangeSpendLimitComponent
  },
  {
    path: "manage-change-tariff-plan",
    component: DemoManageChangeTariffPlanComponent
  },
  {
    path: "sim-management",
    component: DemoSimManagementComponent
  },
  {
    path: "user-management",
    component: DemoUserManagementComponent
  },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class DemosRoutingModule { }
